export default {
  en() {
    return {
      additionalHotelDisclaimer: 'Additional taxes and fees may apply during checkout and upon check-in at the hotel. Transportation not included.',
      amenities: 'Amenities',
      airportShuttle: 'Airport Shuttle',
      back: 'Back to package',
      breakfast: 'Complimentary Breakfast',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkoutStep: 'Checkout',
      chooseAccomodation: 'Choose Your Accommodations',
      chooseAccomodationDescription: 'Below is a listing of hotel offerings through {brand_name}. If you don\'t need a hotel, ',
      chooseOptionalAccomodation: 'Choose Your Optional Accommodation',
      chooseRoom: 'Choose Room',
      chooseARoom: 'Choose A Room',
      clickHereToContinue: 'click here to continue to checkout.',
      contractedTotal: 'for {checkIn} - {checkOut}',
      cugAccountLink:'Purchased a hotel through our booking portal? Give us a call at 1.512.691.9555 for any questions related to your previous orders.',
      destination: 'Destination',
      destinationPlaceholder: 'City, State, Country',
      distance: 'Distance',
      exclusiveHotel: 'Exclusive Hotel',
      exclusiveHotelFinePrint: 'Includes taxes, fees and {quantity}night stay',
      featured: 'FEATURED',
      featuredWithTransportation: 'FEATURED: WITH TRANSPORTATION',
      filterBy: 'Filter By',
      fitness: 'Fitness Center',
      imageDisclaimer: 'It is the responsibility of the property chain and/or the individual property to ensure the accuracy of the photos displayed. We are not responsible for any inaccuracies in the photos.',
      internet: 'Internet Access',
      kitchen: 'Kitchen/Kitchenette',
      listView: 'List View',
      mapView: 'Map View',
      nights: 'nights',
      noHotelProceed: 'Don\'t need a hotel? Checkout',
      note: 'NOTE:',
      otherHotels: 'Other Hotel Offerings',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'per night',
      pets: 'Pets Allowed',
      pool: 'Pool',
      price: 'Price',
      propertyDescription: 'Property Description',
      restaurant: 'Restaurant On-Site',
      retailTotal: 'for {quantity} nights',
      reviews: 'Reviews',
      room: 'Room',
      Rooms: 'Rooms',
      roomNum: '# of Rooms',
      rooms: 'Rooms',
      roomRemaining: 'Only {quantity} room remaining',
      roomsRemaining: 'Only {quantity} rooms remaining',
      roomTotal: 'for {quantity} nights',
      seeAllProperties: 'See all properties',
      selectRoom: 'Select Room',
      showAdditionalHotels: 'Show Additional Hotels',
      showLess: 'Show Less',
      showMore: 'Show More',
      somethingDifferent: 'Looking for something different? We have more hotels available.',
      sortBy: 'Sort By',
      sortFilter: 'Sort/Filter',
      starRating: 'Star Rating',
      startsAt: 'Starts at',
      stars: 'stars',
      tbd: ' total',
      toFromHotel: 'One-time transportation to and from the event venue and hotel on days included with purchase',
      updateSearch: 'Update Search',
      userReviews: 'User Reviews',
      yourPackage: 'Your Package',
    }
  },

  enGB() {
    return {
      additionalHotelDisclaimer: 'Additional taxes and fees may apply during checkout and upon check-in at the hotel. Transportation not included.',
      amenities: 'Amenities',
      airportShuttle: 'Airport Shuttle',
      back: 'Back to package',
      breakfast: 'Complimentary Breakfast',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkoutStep: 'Checkout',
      chooseAccomodation: 'Choose Your Accommodations',
      chooseAccomodationDescription: 'Below is a listing of hotel offerings through {brand_name}. If you don\'t need a hotel, ',
      chooseOptionalAccomodation: 'Choose Your Optional Accommodation',
      chooseRoom: 'Choose Room',
      chooseARoom: 'Choose A Room',
      clickHereToContinue: 'click here to continue to checkout.',
      contractedTotal: 'for {checkIn} - {checkOut}',
      cugAccountLink:'Purchased a hotel through our booking portal? Give us a call at 1.512.691.9555 for any questions related to your previous orders.',
      destination: 'Destination',
      destinationPlaceholder: 'City, State, Country',
      distance: 'Distance',
      exclusiveHotel: 'Exclusive Hotel',
      exclusiveHotelFinePrint: 'Includes taxes, fees and {quantity}night stay',
      featured: 'FEATURED',
      featuredWithTransportation: 'FEATURED: WITH TRANSPORTATION',
      filterBy: 'Filter By',
      fitness: 'Fitness Center',
      imageDisclaimer: 'It is the responsibility of the property chain and/or the individual property to ensure the accuracy of the photos displayed. We are not responsible for any inaccuracies in the photos.',
      internet: 'Internet Access',
      kitchen: 'Kitchen/Kitchenette',
      listView: 'List View',
      mapView: 'Map View',
      nights: 'nights',
      noHotelProceed: 'Don\'t need a hotel? Checkout',
      note: 'NOTE:',
      otherHotels: 'Other Hotel Offerings',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'per night',
      pets: 'Pets Allowed',
      pool: 'Pool',
      price: 'Price',
      propertyDescription: 'Property Description',
      restaurant: 'Restaurant On-Site',
      retailTotal: 'for {quantity} nights',
      reviews: 'Reviews',
      Rooms: 'Rooms',
      roomNum: '# of Rooms',
      room: 'Room',
      rooms: 'Rooms',
      roomRemaining: 'Only {quantity} room remaining',
      roomsRemaining: 'Only {quantity} rooms remaining',
      roomTotal: 'for {quantity} nights',
      seeAllProperties: 'See all properties',
      selectRoom: 'Select Room',
      showAdditionalHotels: 'Show Additional Hotels',
      showLess: 'Show Less',
      showMore: 'Show More',
      somethingDifferent: 'Looking for something different? We have more hotels available.',
      sortBy: 'Sort By',
      sortFilter: 'Sort/Filter',
      starRating: 'Star Rating',
      startsAt: 'Starts at',
      stars: 'stars',
      tbd: ' total',
      toFromHotel: 'One-time transportation to and from the event venue and hotel on days included with purchase',
      updateSearch: 'Update Search',
      userReviews: 'User Reviews',
      yourPackage: 'Your Package',
    }
  },

  // AR is not being done (defaults to en-GB)
  ar() {
    return {
      additionalHotelDisclaimer: 'Additional taxes and fees may apply during checkout and upon check-in at the hotel. Transportation not included.',
      amenities: 'Amenities',
      airportShuttle: 'Airport Shuttle',
      back: 'Back to package',
      breakfast: 'Complimentary Breakfast',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkoutStep: 'Checkout',
      chooseAccomodation: 'Choose Your Accommodations',
      chooseAccomodationDescription: 'Below is a listing of hotel offerings through {brand_name}. If you don\'t need a hotel, ',
      chooseOptionalAccomodation: 'Choose Your Optional Accommodation',
      chooseRoom: 'Choose Room',
      chooseARoom: 'Choose A Room',
      clickHereToContinue: 'click here to continue to checkout.',
      contractedTotal: 'for {checkIn} - {checkOut}',
      cugAccountLink:'Purchased a hotel through our booking portal? Give us a call at 1.512.691.9555 for any questions related to your previous orders.',
      destination: 'Destination',
      destinationPlaceholder: 'City, State, Country',
      distance: 'Distance',
      exclusiveHotel: 'Exclusive Hotel',
      exclusiveHotelFinePrint: 'Includes taxes, fees and {quantity} night stay',
      featured: 'FEATURED',
      featuredWithTransportation: 'FEATURED: WITH TRANSPORTATION',
      filterBy: 'Filter By',
      fitness: 'Fitness Center',
      imageDisclaimer: 'It is the responsibility of the property chain and/or the individual property to ensure the accuracy of the photos displayed. We are not responsible for any inaccuracies in the photos.',
      internet: 'Internet Access',
      kitchen: 'Kitchen/Kitchenette',
      listView: 'List View',
      mapView: 'Map View',
      nights: 'nights',
      noHotelProceed: 'Don\'t need a hotel? Checkout',
      note: 'NOTE:',
      otherHotels: 'Other Hotel Offerings',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'per night',
      pets: 'Pets Allowed',
      pool: 'Pool',
      price: 'Price',
      propertyDescription: 'Property Description',
      restaurant: 'Restaurant On-Site',
      retailTotal: 'for {quantity} nights',
      reviews: 'Reviews',
      roomNum: '# of Rooms',
      room: 'Room',
      rooms: 'Rooms',
      roomTotal: 'for {quantity} nights',
      seeAllProperties: 'See all properties',
      selectRoom: 'Select Room',
      showAdditionalHotels: 'Show Additional Hotels',
      showLess: 'Show Less',
      showMore: 'Show More',
      somethingDifferent: 'Looking for something different? We have more hotels available.',
      sortBy: 'Sort By',
      starRating: 'Star Rating',
      startsAt: 'Starts at',
      stars: 'stars',
      toFromHotel: 'One-time transportation to and from the event venue and hotel on days included with purchase',
      updateSearch: 'Update Search',
      userReviews: 'User Reviews',
      yourPackage: 'Your Package',
    }
  },

  // IT complete
  it() {
    return {
      additionalHotelDisclaimer: 'Potrebbero essere applicate delle imposte e delle commissioni aggiuntive al momento del check-out e del check-in in albergo. Trasferimenti non inclusi.',
      amenities: 'Servizi e attrattive',
      airportShuttle: 'Navetta da/per l\'aeroporto',
      back: 'Ritorna al pacchetto',
      breakfast: 'Colazione inclusa',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkoutStep: 'Cassa',
      chooseAccomodation: 'Scegli la sistemazione',
      chooseAccomodationDescription: 'Di seguito troverai un elenco di alberghi offerti da {brand_name}. In caso non avessi bisogno di un albergo,',
      chooseOptionalAccomodation: 'Scegli la sistemazione opzionale',
      chooseRoom: 'Scegli la stanza',
      chooseARoom: 'Scegli una stanza',
      clickHereToContinue: 'Clicca qui per continuare verso la cassa',
      cugAccountLink:'Hai prenotato un albergo sul nostro portale online? Telefonaci al numero +1.512.691.9555 per qualsiasi domanda relativa ai tuoi ordini.',
      contractedTotal: '{total} per {checkIn} - {checkOut}',
      destination: 'Destinazione',
      destinationPlaceholder: 'Città, Stato/Regione, Paese',
      distance: 'Distanza',
      exclusiveHotel: 'Albergo esclusivo',
      exclusiveHotelFinePrint: 'Include imposte, commissioni e soggiorno di {quantity} notti',
      exclusiveHotelFinePrintContinued: '',
      featured: 'IN EVIDENZA',
      featuredWithTransportation: 'IN EVIDENZA: CON TRASPORTO',
      filterBy: 'Filtra per',
      fitness: 'Centro fitness',
      for: 'for',
      imageDisclaimer: 'È responsabilità della catena e/o della singola struttura garantire l\'accuratezza delle fotografie mostrate. Non possiamo essere ritenuti responsabili per eventuali inesattezze presenti nelle foto.',
      internet: 'Accesso ad Internet',
      kitchen: 'Cucina o angolo cottura',
      listView: 'Elenco',
      mapView: 'Mappa',
      nights: 'nights',
      noHotelProceed: 'Non hai bisogno di un albergo? Cassa',
      note: 'NOTA BENE:',
      otherHotels: 'Altre offerte alberghiere',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'per notte',
      pets: 'Animali ammessi',
      pool: 'Piscina',
      price: 'Prezzo',
      propertyDescription: 'Descrizione della struttura',
      restaurant: 'Ristorante sul posto',
      reviews: 'Dicono di noi',
      roomNum: '# di stanze',
      roomTotal: 'per {quantity} notti',
      room: 'Stanza',
      rooms: 'Stanze',
      seeAllProperties: 'Vedi tutte le strutture',
      selectRoom: 'Scegli stanza',
      showAdditionalHotels: 'Mostra ulteriori alberghi',
      showLess: 'Mostra di meno',
      showMore: 'Mostra di più',
      somethingDifferent: 'Cerchi qualcosa di diverso? Abbiamo ulteriori alberghi a disposizione.',
      sortBy: 'Ordina per',
      starRating: 'Stelle',
      startsAt: 'Prezzo da',
      stars: 'Stelle',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: 'Aggiorna ricerca',
      userReviews: 'Recensioni degli utenti',
      yourPackage: 'Il tuo pacchetto',
    }
  },

  // FR complete
  fr() {
    return {
      additionalHotelDisclaimer: 'Des taxes et frais supplémentaires peuvent s\'appliquer durant le paiement et au moment de l\'enregistrement à l\'hôtel. Le transport n\'est pas inclus.',
      amenities: 'Commodités',
      airportShuttle: 'Navette aéroport',
      back: 'Retour à la page du forfait',
      breakfast: 'Petit déjeuner inclus',
      checkIn: 'Arrivée',
      checkOut: 'Départ',
      checkoutStep: 'Passer à la caisse',
      chooseAccomodation: 'Choisissez votre hébergement.',
      chooseAccomodationDescription: 'Vous trouverez ci-dessous une liste d\'offres d\'hôtels via {brand_name}. Si vous n\'avez pas besoin d\'un hôtel,',
      chooseOptionalAccomodation: 'Choisissez vos prestations de séjour en option.',
      chooseRoom: 'Choisissez votre chambre',
      chooseARoom: 'Choisissez une chambre',
      clickHereToContinue: 'Cliquez ici pour procéder au paiement.',
      contractedTotal: '{total} pour le {checkIn} - {checkOut}',
      destination: 'Destination',
      destinationPlaceholder: 'Ville, État, Pays',
      distance: 'Distance',
      exclusiveHotel: 'Hôtel exclusif',
      exclusiveHotelFinePrint: 'Inclut les taxes, les frais et un séjour de {quantity} nuitées.',
      featured: 'EN PROMO',
      featuredWithTransportation: 'EN PROMO : NAVETTE INCLUSE',
      filterBy: 'Filtrer par',
      fitness: 'Centre de fitness',
      for: 'for',
      imageDisclaimer: 'Il incombe à la chaîne et/ou au particulier propriétaire(s) de l\'établissement d\'assurer l\'exactitude des photos affichées. Nous ne sommes pas responsables de toute inexactitude apparaissant sur les photos.',
      internet: 'Accès Internet',
      kitchen: 'Cuisine/Kitchenette',
      listView: 'Liste',
      mapView: 'Carte',
      nights: 'nights',
      noHotelProceed: 'Vous n\'avez pas besoin d\'un hôtel ? Procédez au paiement.',
      note: 'À NOTER:',
      otherHotels: 'Autres offres d\'hôtels',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'par nuitée',
      pets: 'Animaux de compagnie acceptés',
      pool: 'Bassin',
      price: 'Tarif',
      propertyDescription: 'Description de la propriété',
      restaurant: 'Restaurant sur place',
      reviews: 'Avis',
      room: 'Room',
      Rooms: 'Rooms',
      roomNum: '# de chambre(s)',
      rooms: 'Chambres',
      seeAllProperties: 'Voir toutes les propriétés',
      selectRoom: 'Choisir une chambre',
      showAdditionalHotels: 'Afficher plus d\'hôtels',
      showLess: 'Afficher moins',
      showMore: 'Afficher plus',
      somethingDifferent: 'Vous cherchez quelque chose de différent ? Nous avons plus d\'hôtels disponibles.',
      sortBy: 'Trier par',
      sortFilter: 'Trier/Filtrer',
      starRating: 'Nombre d\'étoiles',
      startsAt: 'Commence à',
      stars: 'Étoiles',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: 'Mettre à jour la recherche',
      userReviews: 'Avis des utilisateurs',
      yourPackage: 'Votre forfait',
    }
  },

  // JA complete
  ja() {
    return {
      additionalHotelDisclaimer: 'ホテルでのチェックアウト時およびチェックイン時に、追加の税金と手数料が適用される場合があります。交通費は含まれていません。',
      amenities: '設備･アメニティ',
      airportShuttle: '空港シャトル',
      back: 'パッケージへ戻る',
      breakfast: '無料の朝食',
      checkIn: 'チェックイン',
      checkOut: 'チェックアウト',
      checkoutStep: 'レジ',
      chooseAccomodation: '宿泊施設を選ぶ',
      chooseAccomodationDescription: '以下は、{brand_name}を通じて提供されるホテルのリストです。ホテルが必要ない場合は',
      chooseOptionalAccomodation: 'オプションの宿泊施設を選択してください',
      chooseRoom: '部屋を選ぶ',
      chooseARoom: '部屋を選ぶ',
      clickHereToContinue: 'チェックアウトを続けるにはここをクリックしてください',
      cugAccountLink:'当社予約ポータルからホテルを購入された方で、以前の注文に関する質問がある場合は、 1.512.691.9555へお電話ください。',
      contractedTotal: '{checkIn} - {checkOut}で、{total}',
      destination: '行き先',
      destinationPlaceholder: '市、州、国',
      distance: '距離',
      exclusiveHotel: '高級ホテル',
      exclusiveHotelFinePrint: '税金、手数料含む、 {quantity} 泊滞在',
      featured: '特徴',
      featuredWithTransportation: '特徴：輸送機関あり',
      filterBy: '検索条件',
      fitness: 'フィットネスセンター',
      for: 'for',
      imageDisclaimer: '表示される写真の正確さは、個々の特質によって異なります。不確かな写真については責任を負いません。',
      internet: 'インターネットアクセス',
      kitchen: 'キッチン/簡易キッチン',
      listView: 'リストビュー',
      mapView: 'マップビュー',
      nights: 'nights',
      noHotelProceed: 'ホテルは必要ありませんか？確認しましょう',
      note: '注意:',
      otherHotels: 'その他のホテル',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: '一泊あたり',
      pets: 'ペット可',
      pool: 'プール',
      price: '価格',
      propertyDescription: 'プロパティの説明',
      restaurant: 'レストラン - 現地',
      reviews: 'レビュー',
      roomNum: '# 部屋',
      room: '部屋',
      rooms: '部屋',
      roomTotal: '{quantity} 泊',
      seeAllProperties: '全プロパティを見る',
      selectRoom: '部屋を選ぶ',
      showAdditionalHotels: '追加ホテルを表示',
      showLess: '表示を減らす',
      showMore: '表示を増やす',
      somethingDifferent: '別のものをお探しですか？利用可能なホテルが他にもあります。',
      sortBy: '並び替え',
      starRating: '星評価',
      startsAt: '星',
      stars: '星の数',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: '検索更新',
      userReviews: 'ユーザーレビュー',
      yourPackage: 'パッケージ',
    }
  },

  // DE is waiting for featured and featuredWithTransportation
  de() {
    return {
      additionalHotelDisclaimer: 'Beim Ein- oder Auschecken im Hotel können zusätzliche Steuern und Gebühren anfallen. Transfers sind nicht inbegriffen.',
      amenities: 'Einrichtungen',
      airportShuttle: 'Flughafen-Shuttle',
      back: 'Zurück zum Paket',
      breakfast: 'Kostenloses Frühstück',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkoutStep: 'Kasse',
      chooseAccomodation: 'Wählen Sie Ihre Unterkunft',
      chooseAccomodationDescription: 'Nachstehend finden Sie eine Auflistung von Hotelangeboten durch {brand_name}. Wenn Sie kein Hotel benötigen,',
      chooseOptionalAccomodation: 'Wählen Sie Ihre optionale Unterkunft',
      chooseRoom: 'Zimmer wählen',
      chooseARoom: 'Wählen Sie ein Zimmer',
      clickHereToContinue: 'klicken Sie hier, um zur Kasse zu gelangen',
      contractedTotal: '{total} für {checkIn} - {checkOut}',
      destination: 'Reiseziel',
      destinationPlaceholder: 'Stadt, Staat/Provinz, Land',
      distance: 'Distanz',
      exclusiveHotel: 'Exklusives Hotel',
      exclusiveHotelFinePrint: 'Inklusive Steuern, Gebühren und {quantity} Übernachtungen',
      featured: '',
      featuredWithTransportation: '',
      filterBy: 'Filtern nach',
      fitness: 'Fitnesscenter',
      for: 'for',
      imageDisclaimer: 'Es liegt in der Verantwortung der Hotelkette und/oder des einzelnen Hotels, die Genauigkeit der gezeigten Bilder zu gewährleisten. Wir sind nicht für ungenaue oder fehlerhafte Bilder verantwortlich.',
      internet: 'Internetzugang',
      kitchen: 'Küche/Kochnische',
      listView: 'Listenansicht',
      mapView: 'Kartenansicht',
      nights: 'nights',
      noHotelProceed: 'Benötigen Sie kein Hotel? Zur Kasse',
      note: 'HINWEIS:',
      otherHotels: 'Weitere Hotelangebote',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'pro Nacht',
      pets: 'Haustiere erlaubt',
      pool: 'zwembad',
      price: 'Preis',
      propertyDescription: 'Hotelbeschreibung',
      restaurant: 'Restaurant vor Ort',
      reviews: 'Bewertungen',
      Rooms: 'Rooms',
      roomNum: 'Anzahl Zimmer',
      room: 'Zimmer',
      rooms: 'Zimmer',
      seeAllProperties: 'Alle Hotels anzeigen',
      selectRoom: 'Zimmer auswählen',
      showAdditionalHotels: 'Weitere Hotels anzeigen',
      showLess: 'Weniger anzeigen',
      showMore: 'Mehr anzeigen',
      somethingDifferent: 'Suchen Sie etwas anderes? Wir bieten noch weitere Hotels an.',
      sortBy: 'Sortieren nach',
      sortFilter: 'Sortieren/Filtern',
      starRating: 'Sternebewertung',
      startsAt: 'Ab',
      stars: 'Sterne',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: 'Suche aktualisieren',
      userReviews: 'Kundenbewertungen',
      yourPackage: 'Ihr Paket',
    }
  },

  // Below needs translations
  esMX() {
    return {
      additionalHotelDisclaimer: '', // Needs translation
      amenities: 'Amenidades',
      airportShuttle: 'Shuttle al Aeropuerto',
      back: 'Regresar al paquete',
      breakfast: 'Desayuno en Cortesía',
      checkIn: 'Entrada',
      checkOut: 'Salida',
      checkoutStep: 'Proceder al Pago',
      chooseAccomodation: 'Elija Su Alojamiento',
      chooseAccomodationDescription: '', //
      chooseOptionalAccomodation: '', //
      chooseRoom: 'Elegir Habitación',
      chooseARoom: 'Elija una Habitación',
      clickHereToContinue: 'haga clic aquí para continuar al pago',
      contractedTotal: '{total} por {checkIn} - {checkOut}',
      destination: 'Destino',
      destinationPlaceholder: 'Ciudad, Estado, País',
      distance: 'Distancia',
      exclusiveHotel: 'Hotel Exclusivo',
      exclusiveHotelFinePrint: '', //
      featured: 'DESTACADO',
      featuredWithTransportation: 'DESTACADO: CON TRANSPORTACIÓN',
      filterBy: 'Filtrar Por',
      fitness: 'Centro de Fitness',
      for: 'for',
      imageDisclaimer: '', //
      internet: 'Acceso a Internet',
      kitchen: 'Cocina/Cocineta',
      listView: 'Vista de Lista',
      mapView: '',
      nights: 'noches',
      noHotelProceed: '¿No necesita un hotel? Proceder al pago',
      note: 'NOTA:',
      otherHotels: '', //
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: 'por noche',
      pets: 'Mascotas Permitidas',
      pool: 'Piscina',
      price: 'Precio',
      propertyDescription: 'Descripción de la Propiedad',
      restaurant: 'Restaurante en el Sitio',
      reviews: 'Reseñas',
      roomNum: '# de Habitaciones',
      room:'Habitación',
      rooms: 'Habitaciones',
      roomTotal: 'por {quantity} noches',
      seeAllProperties: 'Ver todas las propiedades',
      selectRoom: 'Seleccionar Habitación',
      showAdditionalHotels: 'Mostrar Hoteles Adicionales',
      showLess: 'Ver Menos',
      showMore: 'Ver Más',
      somethingDifferent: '¿Busca algo distinto? Tenemos más hoteles disponibles.',
      sortBy: '',
      starRating: '', //
      startsAt: 'Empieza en',
      stars: 'Estrellas',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: 'Actualizar Búsqueda',
      userReviews: 'Reseñas de Usuarios',
      yourPackage: 'Su Paquete',
    }
  },

  // zhCN needs transport and transportWithTransportation translated
  zhCN() {
    return {
      additionalHotelDisclaimer: '在酒店办理入住和退房手续时可能需要支付额外的税费。不包含交通费。',
      amenities: '便利设施',
      airportShuttle: '机场接送',
      back: '返回套餐',
      breakfast: '免费早餐',
      checkIn: '入住时间',
      checkOut: '退房时间',
      checkoutStep: '结账',
      chooseAccomodation: '选择您的住宿',
      chooseAccomodationDescription: '以下是通过{brand_name}提供的酒店清单。如果您不需要预订酒店，',
      chooseOptionalAccomodation: '选择您的可选酒店',
      chooseRoom: '选择房间',
      chooseARoom: '选择一个房间',
      clickHereToContinue: '点击此处继续结帐',
      cugAccountLink: '已从我们的预订页面预订酒店？如有任何有关之前订单的疑问，请致电1.512.691.9555。',
      contractedTotal: '{checkIn} - {checkOut} {total} 晚',
      destination: '目的地',
      destinationPlaceholder: '市，州，国家',
      distance: '距离',
      exclusiveHotel: '专属酒店',
      exclusiveHotelFinePrint: '含税、费用和{quantity}晚住宿',
      featured: '',
      featuredWithTransportation: '',
      filterBy: '筛选条件',
      fitness: '健身房',
      for: 'for',
      imageDisclaimer: '所展示照片的精确性由属性链和/或单个属性决定，我们对照片中的任何错误概不负责。',
      internet: '互联网接入',
      kitchen: '厨房/小厨房',
      listView: '列表视图',
      mapView: '查看地图',
      nights: 'nights',
      noHotelProceed: '不需要酒店？结账',
      note: '注意:',
      otherHotels: '其他酒店产品',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: '每晚',
      pets: '允许携带宠物',
      pool: '泳池',
      price: '价钱',
      propertyDescription: '酒店介绍',
      restaurant: '内部餐厅',
      reviews: '评论',
      roomTotal: '{quantity}晚',
      roomNum: '房间数',
      room: '房间',
      rooms: '房间',
      seeAllProperties: '查看所有酒店',
      selectRoom: '选择房间',
      showAdditionalHotels: '显示更多酒店',
      showLess: '显示较少',
      showMore: '显示更多',
      somethingDifferent: '想寻求与以往不同的尝试？ 我们还有更多酒店可供选择。',
      sortBy: '检索结果排序',
      starRating: '星级',
      startsAt: '始于',
      stars: '星星',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: '更新搜索',
      userReviews: '用户评论',
      yourPackage: '您的套餐',
    }
  },

  // PL needs just about everything
  pl() {
    return {
      additionalHotelDisclaimer: '',
      amenities: 'udogodnienia',
      airportShuttle: '',
      back: '',
      breakfast: '',
      checkIn: 'zameldowanie:',
      checkOut: 'wymeldowanie',
      checkoutStep: 'przejdź do kasy',
      chooseAccomodation: '',
      chooseAccomodationDescription: '',
      chooseOptionalAccomodation: '',
      chooseRoom: '',
      chooseARoom: '',
      clickHereToContinue: '',
      cugAccountLink: '',
      contractedTotal: '',
      destination: '',
      destinationPlaceholder: '',
      distance: '',
      exclusiveHotel: '',
      exclusiveHotelFinePrint: '',
      exclusiveHotelFinePrintContinued: '',
      featured: '',
      featuredWithTransportation: '',
      filterBy: '',
      fitness: '',
      for: '',
      imageDisclaimer: '',
      internet: '',
      kitchen: '',
      listView: '',
      mapView: '',
      nights: '',
      noHotelProceed: '',
      note: 'UWAGA:',
      otherHotels: '',
      packageSuccess: 'Success! {package_name} has been added to your cart.',
      perNight: '',
      pets: '',
      pool: 'Basen',
      price: 'cena',
      propertyDescription: '',
      restaurant: '',
      reviews: '',
      Rooms: 'Rooms',
      roomNum: '',
      room: 'Room',
      rooms: 'Rooms',
      seeAllProperties: '',
      selectRoom: '',
      showAdditionalHotels: '',
      showLess: '',
      showMore: '',
      somethingDifferent: '',
      sortBy: '',
      sortFilter: '',
      starRating: '',
      startsAt: '',
      stars: 'gwiazdki',
      tbd: ' total',
      toFromHotel: '',
      updateSearch: '',
      userReviews: '',
      yourPackage: '',
    }
  }
}
